/**
 * Filter types and configuration for the Work Queue
 */

import type { IssueTagType } from '../../../domain'

export interface FilterChipConfig {
  tagType: IssueTagType
  label: string
}

export const FILTER_CHIPS: FilterChipConfig[] = [
  { tagType: 'RECOMMENDED', label: 'Recommended' },
  { tagType: 'QUICK_WIN', label: 'Quick Wins' },
  { tagType: 'OVERDUE', label: 'Overdue' },
  { tagType: 'BLOCKED', label: 'Blocked' },
  { tagType: 'FAMILIAR', label: 'Familiar' },
]

export type WorkQueueSortBy = 'createdAt' | 'severity'
export type WorkQueueSortDirection = 'asc' | 'desc'

export type TagCounts = Record<IssueTagType, number>
